import React from "react";
import { Route, Routes } from "react-router-dom";
import FarmerDailyActivityEdit from "../component/farmer/dailyActivity/FarmerDailyActivityEdit";
import FarmerHarvestEdit from "../component/farmer/harvest/FarmerHarvestEdit";
import FarmerHarvestTambah from "../component/farmer/harvest/FarmerHarvestTambah";
import FarmerHarvestEstimateEdit from "../component/farmer/harvestEstimate/FarmerHarvestEstimateEdit";
import FarmerHarvestEstimateTambah from "../component/farmer/harvestEstimate/FarmerHarvestEstimateTambah";
import SpvReportHarvestEstimate from "../component/supervisor/report/harvestEstimate/SpvReportHarvestEstimate";
import SpvReportHarvest from "../component/supervisor/report/harvest/SpvReportHarvest";
import SpvReportHarvestFarmer from "../component/supervisor/report/harvestFarmer/SpvReportHarvestFarmer";
import SpvReportHarvestEstimateFarmer from "../component/supervisor/report/harvestEstimateFarmer/SpvReportHarvestEstimateFarmer";
import SpvReportDailyActivity from "../component/supervisor/report/dailyActivityAll/SpvReportDailyActivity";
import SpvReportActivity from "../component/supervisor/report/dailyActivity/SpvReportActivity";
import SpvReportNoActivity from "../component/supervisor/report/dailyNoActivity/SpvReportNoActivity";
import SpvReportActivityDetail from "../component/supervisor/report/dailyActivityDetail/SpvReportActivityDetail";
import PrivateRoute from "./PrivateRoute";
import Login from "../component/login/Login";
import AdminMain from "../component/layout/AdminMain";
import FarmerDailyActivity from "../component/farmer/dailyActivity/FarmerDailyActivity";
import FarmerDailyActivityDetail from "../component/farmer/dailyActivity/FarmerDailyActivityDetail";
import FarmerDailyActivityTambah from "../component/farmer/dailyActivity/FarmerDailyActivityTambah";
import FarmerHarvestEstimate from "../component/farmer/harvestEstimate/FarmerHarvestEstimate";
import FarmerHarvestEstimateDetail from "../component/farmer/harvestEstimate/FarmerHarvestEstimateDetail";
import FarmerHarvest from "../component/farmer/harvest/FarmerHarvest";
import FarmerHarvestDetail from "../component/farmer/harvest/FarmerHarvestDetail";
import AdminPurchaseOrder from "../component/farmer/purchaseOrder/AdminPurchaseOrder";
import AdminPurchaseOrderDetail from "../component/farmer/purchaseOrder/AdminPurchaseOrderDetail";

export default function SupervisorRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route
        path="/admin"
        element={
          <PrivateRoute>
            <AdminMain />
          </PrivateRoute>
        }
      />
      <Route
        path="/petani"
        element={
          <PrivateRoute>
            <AdminMain />
          </PrivateRoute>
        }
      >
        <Route
          path="/petani/aktifitas-harian"
          element={
            <PrivateRoute>
              <FarmerDailyActivity />
            </PrivateRoute>
          }
        />
        <Route
          path="/petani/aktifitas-harian/detail/:id"
          element={
            <PrivateRoute>
              <FarmerDailyActivityDetail />
            </PrivateRoute>
          }
        />
        <Route
          path="/petani/aktifitas-harian/edit/:id"
          element={
            <PrivateRoute>
              <FarmerDailyActivityEdit />
            </PrivateRoute>
          }
        />
        <Route
          path="/petani/aktifitas-harian/tambah"
          element={
            <PrivateRoute>
              <FarmerDailyActivityTambah />
            </PrivateRoute>
          }
        />

        <Route
          path="/petani/estimasi-panen"
          element={
            <PrivateRoute>
              <FarmerHarvestEstimate />
            </PrivateRoute>
          }
        />
        <Route
          path="/petani/estimasi-panen/detail/:id"
          element={
            <PrivateRoute>
              <FarmerHarvestEstimateDetail />
            </PrivateRoute>
          }
        />
        <Route
          path="/petani/estimasi-panen/tambah"
          element={
            <PrivateRoute>
              <FarmerHarvestEstimateTambah />
            </PrivateRoute>
          }
        />
        <Route
          path="/petani/estimasi-panen/edit/:id"
          element={
            <PrivateRoute>
              <FarmerHarvestEstimateEdit />
            </PrivateRoute>
          }
        />

        <Route
          path="/petani/panen"
          element={
            <PrivateRoute>
              <FarmerHarvest />
            </PrivateRoute>
          }
        />
        <Route
          path="/petani/panen/detail/:id"
          element={
            <PrivateRoute>
              <FarmerHarvestDetail />
            </PrivateRoute>
          }
        />
        <Route
          path="/petani/panen/edit/:id"
          element={
            <PrivateRoute>
              <FarmerHarvestEdit />
            </PrivateRoute>
          }
        />
        <Route
          path="/petani/panen/tambah"
          element={
            <PrivateRoute>
              <FarmerHarvestTambah />
            </PrivateRoute>
          }
        />

        <Route
          path="/petani/nota-petani"
          element={
            <PrivateRoute>
              <AdminPurchaseOrder />
            </PrivateRoute>
          }
        />
        <Route
          path="/petani/nota-petani/detail/:id"
          element={
            <PrivateRoute>
              <AdminPurchaseOrderDetail />
            </PrivateRoute>
          }
        />
      </Route>
      <Route
          path="/spv"
          element={
            <PrivateRoute>
              <AdminMain />
            </PrivateRoute>
          }
        >
          <Route
            path="/spv/laporan/aktifitas-petani"
            element={
              <PrivateRoute>
                <SpvReportDailyActivity />
              </PrivateRoute>
            }
          />
          <Route
            path="/spv/laporan/aktifitas-petani/beraktifitas"
            element={
              <PrivateRoute>
                <SpvReportActivity />
              </PrivateRoute>
            }
          />
          <Route
            path="/spv/laporan/aktifitas-petani/tidak-beraktifitas"
            element={
              <PrivateRoute>
                <SpvReportNoActivity />
              </PrivateRoute>
            }
          />
          <Route
            path="/spv/laporan/aktifitas-petani/detail"
            element={
              <PrivateRoute>
                <SpvReportActivityDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/spv/laporan/estimasi-panen"
            element={
              <PrivateRoute>
                <SpvReportHarvestEstimate />
              </PrivateRoute>
            }
          />
          <Route
            path="/spv/laporan/panen"
            element={
              <PrivateRoute>
                <SpvReportHarvest />
              </PrivateRoute>
            }
          />
          <Route
            path="/spv/laporan/panen/petani"
            element={
              <PrivateRoute>
                <SpvReportHarvestFarmer />
              </PrivateRoute>
            }
          />
          <Route
            path="/spv/laporan/estimasi-panen/petani"
            element={
              <PrivateRoute>
                <SpvReportHarvestEstimateFarmer />
              </PrivateRoute>
            }
          />
        </Route>
    </Routes>
  );
}
